/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import AnalyticsUtil from './AnalyticsUtil';
import { getAppLocale } from '@intl/adobe-locales';

export default class TrailheadFooterAnalytics {
	ingest: ingestObject;
	analyticsUtils: AnalyticsUtil;
	locale: string;

	constructor() {
		this.analyticsUtils = new AnalyticsUtil();
		this.ingest = this.analyticsUtils.ingest;
		this.locale;
	}

	/**
	 * Set locale for all analytics. (Normally comes from IMS but needs to be manually set
	 * for logged out users.)
	 * @param {string} locale
	 */
	setLocale(locale: string) {
		this.locale = getAppLocale('ims', locale, 'en_US');
	}

	/**
	 * [logAnalytics A utility method to set multiple values at once]
	 * @param  {[object of key/value pairs]} dataObject [events]
	 * @return {[none]}
	 */
	logAnalytics(dataObject: Record<string, unknown>) {
		if (
			window &&
			window.cchome &&
			window.cchome.util &&
			window.cchome.util.getStartupLanguage() === 'en' &&
			window.cchome &&
			window.cchome.util &&
			window.cchome.util.hasFeature &&
			window.cchome.util.hasFeature('uk')
		) {
			dataObject.setEventLanguage = 'en_UK';
		}
		dataObject.setEventLanguage = dataObject.setEventLanguage || this.locale;
		dataObject.setEventWorkFlow = 'CC Downloads';
		dataObject.setUIViewType = 'Trailhead';
		this.analyticsUtils.logAnalytics(dataObject);
	}

	/**
	 * [sendToIngest Post to ingest]
	 * @return {[none]}
	 */
	sendToIngest() {
		this.analyticsUtils.checkOptin(this.ingest);
	}

	/**
	 * [initAnalytics Init Ingest]
	 * @return {[none]}
	 */
	initAnalytics() {
		this.ingest.initializeDefaultData();
	}

	sendFooterEvent(data: Record<string, unknown>) {
		this.initAnalytics();
		this.logAnalytics(data);
		this.sendToIngest();
	}
}
